// Navigation data: primary links, the compact Pages dropdown, and the footer.
export interface NavLink {
    label: string
    href: string
    external?: boolean
}

export interface NavColumn {
    heading: string
    links: NavLink[]
}

export interface PagesMenuItem {
    label: string
    href: string
    description: string
    external?: boolean
}

/** Primary navbar links (in-page anchors on the home page). */
export const navLinks: NavLink[] = [
    { label: 'Product', href: '/#product' },
    { label: 'Features', href: '/#features' },
    { label: 'Testimonial', href: '/#testimonial' },
    { label: 'Pricing', href: '/#pricing' }
]

/** Primary items in the compact "Pages" dropdown. */
export const pagesMenu: PagesMenuItem[] = [
    { label: 'Home', href: '/', description: 'The Manila overview' },
    { label: 'Blog', href: '/#blog', description: 'Insights and product updates' },
    { label: 'Pricing', href: '/#pricing', description: 'Simple plans for every team' },
    { label: 'Privacy', href: '/privacy', description: 'How we protect your data' }
]

/** Secondary utility links shown in the dropdown footer. */
export const pagesUtility: NavLink[] = [
    { label: 'Blog Post', href: '/post/top-10-modulify-template-categories' },
    { label: '404', href: '/404' }
]

/** Footer link columns. */
export const footerColumns: NavColumn[] = [
    {
        heading: 'Sections',
        links: [
            { label: 'Product', href: '/#product' },
            { label: 'Features', href: '/#features' },
            { label: 'Testimonial', href: '/#testimonial' },
            { label: 'Pricing', href: '/#pricing' }
        ]
    },
    {
        heading: 'Company',
        links: [
            { label: 'Blog', href: '/#blog' },
            { label: 'Privacy', href: '/privacy' }
        ]
    },
    {
        heading: 'Resources',
        links: [
            { label: 'Blog Post', href: '/post/result-driven-modulify-templates' },
            { label: '404', href: '/404' }
        ]
    },
    {
        heading: 'Help',
        links: [
            { label: 'Get Demo', href: '/#cta' },
            { label: 'Contact', href: 'mailto:hello@modulify.ai', external: true }
        ]
    }
]
